import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
  useMutation,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import useGuardianDocumentsService, {
  GuardianDocument,
} from '../../../../apis/guardian/sub-apis/useGuardianDocumentsService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';

type TQueryError = IFHError<{ message: string }>;

export const getGuardianDocumentsKey = 'get-guardian-documents';

export const useGuardianDocumentsHook = (
  studentId: string,
  params: TPaginationParams & { category?: string; type?: string },
  options?: UseQueryOptions<{ data: GuardianDocument[]; count: number }, TQueryError>
): UseQueryResult<{ data: GuardianDocument[]; count: number }, TQueryError> => {
  const { getDocuments } = useGuardianDocumentsService();

  const safeParams = { ...params, page: params.page ?? 1, limit: params.limit ?? 10 };
  return useQuery<{ data: GuardianDocument[]; count: number }, TQueryError>({
    queryKey: [getGuardianDocumentsKey, studentId, safeParams],
    queryFn: () => getDocuments(studentId, safeParams),
    enabled: !!studentId,
    ...options,
  });
};

export const useGuardianDownloadDocumentHook = () => {
  const { downloadDocument } = useGuardianDocumentsService();

  return useMutation<Blob, TQueryError, { studentId: string; documentId: string }>({
    mutationFn: ({ studentId, documentId }) => downloadDocument(studentId, documentId),
  });
};
